var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.87868 0.87868C0 1.75736 0 3.17157 0 6V10.2C0 13.0284 0 14.4426 0.87868 15.3213C1.75736 16.2 3.17157 16.2 6 16.2H12C14.8284 16.2 16.2426 16.2 17.1213 15.3213C18 14.4426 18 13.0284 18 10.2V6C18 3.17157 18 1.75736 17.1213 0.87868C16.2426 0 14.8284 0 12 0H6C3.17157 0 1.75736 0 0.87868 0.87868ZM12.6 4.4C13.1523 4.4 13.6 4.84772 13.6 5.4V12.6C13.6 13.1523 13.1523 13.6 12.6 13.6C12.0477 13.6 11.6 13.1523 11.6 12.6V5.4C11.6 4.84772 12.0477 4.4 12.6 4.4ZM6.4 7.2C6.4 6.64772 5.95228 6.2 5.4 6.2C4.84772 6.2 4.4 6.64772 4.4 7.2V12.6C4.4 13.1523 4.84772 13.6 5.4 13.6C5.95229 13.6 6.4 13.1523 6.4 12.6L6.4 7.2ZM10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9V12.6C8 13.1523 8.44772 13.6 9 13.6C9.55228 13.6 10 13.1523 10 12.6V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.bd15d51fa44826930d7b3874fdb641ac.svg";
export { ForwardRef as ReactComponent };